import {} from "../../request/api";
const state = {
    infoId: null,
    AirspaceListData: null,
};
const mutations = {
    changeInfoId(state, id) {
        state.infoId = id;
    },
    changeAirspaceList(state, list) {
        state.AirspaceListData = list;
    }
};
const actions = {};

const getters = {
    infoId(state) {
        return state.infoId;
    },
    AirspaceListData(state) {
        return state.AirspaceListData;
    }
};

export default {
    state,
    mutations,
    actions,
    getters,
    // 命名空间
    namespaced: true, //使用命名空间
}